import { createSelector } from 'reselect'

import { getTokenFields } from './index'

import { halfHourInMilliseconds } from 'app/services/date'

export const getUserDataValuation = createSelector(
  state => state.form.newValuationForm,
  newValuationForm => {
    const { values = {} } = newValuationForm ? newValuationForm : {}
    return {
      email: values.email ? values.email : '',
      firstName: values.firstName ? values.firstName : '',
      lastName: values.lastName ? values.lastName : '',
      secondLastName: values.secondLastName ? values.secondLastName : '',
      telephone: values.telephone ? values.telephone : '',
      secondTelephone: values.secondTelephone ? values.secondTelephone : '',
      password: values.password ? values.password : ''
    }
  }
)

export const getValuationData = createSelector(
  state => state.form.newValuationForm,
  state => getTokenFields(state),
  (newValuationForm, tokenFields) => {
    if (!tokenFields || !newValuationForm) {
      return null
    }
    const { values = {} } = newValuationForm
    const { shift } = values
    return {
      start: shift ? shift.start : null,
      end: shift ? shift.end : null,
      property: null,
      broker: shift ? shift.broker.id : null,
      landlord: tokenFields.user_id,
      client: null,
      reason: null,
      isConfirmed: false,
      status: 'PENDING',
      type: 'VALUATION',
      valuationData: {
        address: values.address,
        street: values.street,
        streetNumber: values.streetNumber,
        aptNumber: values.aptNumber,
        neighborhood: values.neighborhood,
        district: values.district,
        state: values.state,
        postalCode: values.postalCode,
        lng: values.lng,
        lat: values.lat,
        propertyType: values.propertyType ? values.propertyType.value : null,
        operationType: values.operationType ? values.operationType.value : null,
        bathrooms: values.bathrooms,
        bedrooms: values.bedrooms,
        parkingSpaces: values.parkingSpaces,
        surfaceArea: values.surfaceArea,
        constructionArea: values.constructionArea
      },
      brokerValuationData: null,
      showData: null
    }
  }
)

export const getBrokerValuationData = createSelector(
  state => state.form.brokerValuationForm,
  state => getTokenFields(state),
  (brokerValuationForm, tokenFields) => {
    if (!tokenFields || !brokerValuationForm) {
      return null
    }
    const { values = {} } = brokerValuationForm
    const { shift } = values
    return {
      start: shift ? shift.start : null,
      end: shift ? shift.end : null,
      property: null,
      broker: tokenFields.user_id,
      landlord: null,
      client: null,
      reason: null,
      isConfirmed: false,
      status: 'PENDING',
      type: 'BROKER_VALUATION',
      serviceReason: null,
      brokerValuationData: {
        name: values.name,
        address: values.address
      },
      valuationData: null,
      showData: null,
      customEventData: null
    }
  }
)

export const getBrokerValuationInitialShift = createSelector(
  state => state.form.brokerValuationForm,
  state => getTokenFields(state),
  (brokerValuationForm, tokenFields) => {
    if (!tokenFields || !brokerValuationForm) {
      return null
    }

    const { initial = {} } = brokerValuationForm
    const { shift } = initial

    return shift
  }
)

export const getCustomEventData = createSelector(
  state => state.form.customEventForm,
  state => getTokenFields(state),
  (customEventForm, tokenFields) => {
    if (!tokenFields || !customEventForm) {
      return null
    }
    const { values = {} } = customEventForm

    let selectedStartDate = new Date(values.startDate)
    selectedStartDate = new Date(
      selectedStartDate.valueOf() +
        selectedStartDate.getTimezoneOffset() * 60000
    )
    const start = selectedStartDate.valueOf() + parseInt(values.startTime.value)

    let selectedEndDate = new Date(values.endDate)
    selectedEndDate = new Date(
      selectedEndDate.valueOf() + selectedEndDate.getTimezoneOffset() * 60000
    )
    const end = selectedEndDate.valueOf() + parseInt(values.endTime.value)

    let participants = []
    if (values.participants) {
      participants = values.participants.map(participant => ({
        participantEmail: participant.value
      }))
    }

    return {
      start: start,
      end: end,
      property: null,
      broker: tokenFields.user_id,
      landlord: null,
      client: null,
      reason: null,
      isConfirmed: true,
      status: 'CONFIRMED',
      type: 'CUSTOM_EVENT',
      serviceReason: null,
      brokerValuationData: null,
      valuationData: null,
      showData: null,
      customEventData: {
        title: values.title,
        description: values.description,
        address: values.address,
        customEventParticipants: participants
      }
    }
  }
)

export const getSuccessValuationData = createSelector(
  state => state.form.newValuationForm,
  newValuationForm => {
    if (!newValuationForm) {
      return {
        start: 0,
        end: 0,
        broker: {
          firstName: '',
          lastName: '',
          secondLastName: '',
          email: '',
          telephone: ''
        }
      }
    }
    const { values = {} } = newValuationForm
    const { shift } = values
    return {
      start: shift ? shift.start : null,
      end: shift ? shift.end : null,
      broker: shift ? shift.broker : {}
    }
  }
)

export const getAppointmentStatus = createSelector(
  state => state.form.appointmentStatus,
  appointmentStatus => {
    if (!appointmentStatus) {
      return {
        reason: null,
        status: 'FAILURE'
      }
    }
    const { values = {} } = appointmentStatus
    return {
      reason: values.reason ? values.reason.value : null,
      status: values.status
    }
  }
)

export const formToValuation = ({ propertyInfo, contactInfo }) => {
  const {
    fullName,
    telephone,
    mobilePhone,
    email,
    appointmentDate,
    timeToContact,
  } = contactInfo
  const {
    operationType,
    propertyType,
    postalCode,
    neighborhoodData,
    bathrooms,
    bedrooms,
    price,
  } = propertyInfo
  const { name, stateName, municipalityName } = neighborhoodData
  return {
    operationType,
    propertyType,
    postalCode,
    neighborhood: name,
    state: stateName,
    city: municipalityName,
    bathrooms: bathrooms || null,
    bedrooms: bedrooms || 0,
    price: {
      amount: price.amount,
      currency: price.currency,
    },
    contact: {
      email,
      fullName,
      mobilePhone,
      telephone: telephone || null,
    },
    extra: {
      appointmentDate,
      timeOption: timeToContact,
    },
  }
}
